export const tccLogo = 'TCCLogo.svg';
